export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="glass-header sticky top-0 z-10 px-8 py-5 flex items-end justify-between">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
